/* eslint-disable react/display-name */
import React, { forwardRef, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { getAllCity } from '../../redux/slices/citySlice'
import { isDateAfter, isDateBefore } from '../../helper/function'
import CommonDateTimePicker from '../../component/commonDateTimePicker'

const CleanersFilter = forwardRef((props) => {
  const { showFilter, setShowFilter, handlePagination, setFilterData } = props
  const { handleSubmit, control, trigger, reset, watch, setValue } = useForm({})
  const { allRegion } = useSelector(({ region }) => region)
  const { allCity } = useSelector(({ city }) => city)
  // eslint-disable-next-line no-unused-vars
  const [collapse, setCollapse] = useState(true)

  const { user } = useSelector(({ auth }) => auth)

  const dispatch = useDispatch()

  useEffect(() => {
    const params = {
      region_id: watch('region')?.region_id
    }
    dispatch(getAllCity(watch('region')?.region_id && params))
      .then(() => {})
      .catch(() => {})
  }, [watch('region')])

  // useImperativeHandle(ref, () => ({
  //   resetForm: () => {
  //     reset({
  //       name: '',
  //       region: '',
  //       city_id: '',
  //       created_start: '',
  //       created_end: ''
  //     }) // Resets the form fields
  //   }
  // }))

  const onSubmit = (data) => {
    setFilterData({
      name: data?.name,
      region: data?.region?.region_id,
      city_id: data?.city_id?.city_id,
      created_start: data?.created_start ? data?.created_start : undefined,
      created_end: data?.created_end ? data?.created_end : undefined
    })
    handlePagination(1, 6)
    setShowFilter(!showFilter)
  }

  const handleFilterclear = async () => {
    reset({
      name: '',
      region: '',
      city_id: '',
      created_start: '',
      created_end: ''
    })
    setFilterData({})
    handlePagination(1, 6)
    setShowFilter(!showFilter)
  }

  return (
    <div className={`toggle-sidebar ${showFilter ? 'open-filter' : ''}`}>
      <div className="sidebar-layout-filter">
        <div className="sidebar-header">
          <h5>Filter</h5>
          <Link
            to="#"
            className="sidebar-closes"
            onClick={() => {
              setShowFilter(!showFilter)
            }}
          >
            <i className="fa-regular fa-circle-xmark" />
          </Link>
        </div>
        <div className="sidebar-body">
          <div className="title">Cleaners</div>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Product */}
            <div className="accordion" id="accordionMain1">
              <div
                id="collapseOne"
                className={collapse ? 'collapse show' : 'collapse'}
                aria-labelledby="headingOne"
                data-bs-parent="#accordionExample1"
              >
                <div className="card-body-chat">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="form-group">
                        <label>Cleaner</label>
                        <Controller
                          name="name"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <>
                              <input
                                className="form-control bg-transparent dark_border"
                                autoComplete="off"
                                value={value}
                                type="text"
                                placeholder="Search Cleaner Name"
                                onChange={(val) => {
                                  onChange(val)
                                  trigger('name')
                                }}
                              />
                            </>
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  {user?.role_name !== 'sub_admin' && (
                    <div className="row">
                      <div className="col-lg-12 col-sm-12">
                        <div className="form-group input_text border-remove dark_border_divs">
                          <label>Region</label>
                          <Controller
                            name="region"
                            control={control}
                            render={({ field }) => (
                              <Select
                                {...field}
                                className={`react-selectcomponent form-control select-box-filed`}
                                getOptionLabel={(option) => `${option.region}`}
                                getOptionValue={(option) => `${option.region_id}`}
                                options={allRegion || []}
                                isClearable
                                isSearchable={true}
                                placeholder={`Select Region`}
                                classNamePrefix="select_kanakku"
                                defaultValue={''}
                                onChange={(value) => {
                                  field.onChange(value)
                                  setValue('city_id', '')
                                }}
                              />
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="form-group input_text border-remove dark_border_divs">
                        <label>City</label>
                        <Controller
                          name="city_id"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              className={`react-selectcomponent form-control select-box-filed`}
                              getOptionLabel={(option) => `${option.city}`}
                              getOptionValue={(option) => `${option.city_id}`}
                              options={allCity || []}
                              isClearable
                              isSearchable={true}
                              placeholder={`Select City`}
                              classNamePrefix="select_kanakku"
                              defaultValue={''}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <label style={{ color: 'black' }}>Account created between</label>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>From:</label>
                        <div className="date_picker_main_div">
                          <CommonDateTimePicker
                            name="created_start"
                            control={control}
                            disablePast={false}
                            className="form-control bg-transparent dark_border"
                            placeholder="DD/MM/YYYY"
                            onDateChange={() => {
                              trigger('created_start')
                            }}
                            shouldDisableDate={(date) => isDateAfter(date, watch('created_end'))}
                            type="DatePicker"
                            format="DD/MM/YYYY"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>To:</label>
                        <div className="date_picker_main_div">
                          <CommonDateTimePicker
                            name="created_end"
                            control={control}
                            className="form-control bg-transparent dark_border"
                            placeholder="DD/MM/YYYY"
                            disablePast={false}
                            onDateChange={() => {
                              trigger('created_end')
                            }}
                            shouldDisableDate={(date) => isDateBefore(date, watch('created_start'))}
                            type="DatePicker"
                            format="DD/MM/YYYY"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                <div className="form-group">
                  <label style={{ color: 'black' }}>Rating</label>
                  <div className="col-lg-12 col-sm-12">
                    <Controller
                      name="rating"
                      control={control}
                      render={({ field }) => (
                        <>
                          <Rating
                            size={50}
                            SVGstorkeWidth={2}
                            initialValue={field.value || 5}
                            transition={true}
                            fillIcon={<FeatherIcon icon="star" color={'rgb(255, 188, 11)'} />}
                            emptyIcon={<FeatherIcon icon="star" color={'white'} />}
                            allowFraction
                            onClick={field.onChange}
                          />
                        </>
                      )}
                    />
                  </div>
                </div>
              </div> */}
                </div>
              </div>
            </div>

            {/* /Category */}
            <div className="filter-buttons">
              <button
                type="submit"
                // onClick={handleApplyFilter}
                // disabled={key.length > 0 ? false : true}
                className="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary"
              >
                {/* {key.length > 0 ? 'Apply' : 'Select Client'} */}
                Apply
              </button>
              <button
                type="button"
                onClick={handleFilterclear}
                // disabled={searchText.value == '' && key.length == 0 ? true : false}
                className="d-inline-flex align-items-center justify-content-center btn w-100 btn-secondary"
              >
                Reset
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
})

export default CleanersFilter
